// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2AZPF","row":"Node_row__2hdMF","label":"Node_label__14han","footer":"Node_footer__2qvpg"};